export default __webpack_public_path__ + "static/media/icon_share-this-twitter.351fb70e.svg";